export default __webpack_public_path__ + "media/assets/img/img_icon_box-6791ad114ec8cace645f52e5d4336eb1.svg";